import {useNavigate} from "react-router-dom";
import Checkbox from "../../forms/inputs/Checkboxk";
import ItemMenu from "../../forms/menu/MenuComponent";
import {useTranslation} from "react-i18next";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";

function ProgramTeamItem ({currentUser, team, selectedTeams, hoverTeam, onHover, onDeleteItem, onChange}) {
    const {t} = useTranslation(['common','teams']);
    const navigate = useNavigate();

    const onClickDetail = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_TEAMS, {tag: 'button', event: 'onClick', action: 'click option team detail', team_id: team._id});
        navigate(`/teams/detail/${team._id}`);
    }

    const isChecked = () => {
        return selectedTeams.find((t) => t._id === team._id);
    }

    const isHover = () => {
        return hoverTeam && hoverTeam._id === team._id;
    }

    const handleClick = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_TEAMS, {tag: 'row', event: 'onClick', action: 'click row team', team_id: team._id});
        onHover(team);
    }

    return (
        <div className={`__TeamBase ${isHover() ? 'selected' : ''}`} onClick={handleClick}>
            <div>
                {
                    currentUser.userRoles.userPatients.edit? <Checkbox bool={isChecked()} onChange={() => onChange(team)}/> : ''
                }
            </div>
            <div className="name">
                <h3 onClick={onClickDetail}>{team.name}</h3>
            </div>
            <p>{team.users.length}</p>
            <div>
                {
                    currentUser.userRoles.userPatients.edit?
                        <ItemMenu actionWillRedirect={false} fixed={true} label={'User Options'}
                                  event={PAGES.PROGRAM_TEAMS} eventParams={{team_id: team._id}}>
                            <>
                                <div className="_option" onClick={onClickDetail}>
                                    <p>{t('teams:team-detail')}</p>
                                </div>
                                <div className="_option" onClick={() => onDeleteItem(team)}>
                                    <p>{t('teams:remove-team')}</p>
                                </div>
                            </>
                        </ItemMenu> : ''
                }
            </div>
        </div>
    );
}

export default ProgramTeamItem;
